import { AbstractMessageHandler } from './AbstractMessageHandler.ts'
import { GreetingMessageType } from '../enums'
import { isGreetingMessageType } from '../type-guards'
import { getParentColorScheme } from '../parentColorScheme'

export class GreetingMessageHandler extends AbstractMessageHandler {
  handle(_event: MessageEvent, type: string, payload?: Record<string, unknown>): void {
    try {
      if (!isGreetingMessageType(type)) {
        this.logError('Unknown greeting message type:', type)
        return
      }

      switch (type) {
        case GreetingMessageType.GREETING_READY:
          this.handleGreetingReady()
          break
        case GreetingMessageType.RESIZE_GREETING:
          this.handleResizeGreeting(payload)
          break
        case GreetingMessageType.DISMISS_GREETING:
          this.dismissGreeting()
          break
        case GreetingMessageType.TOGGLE_CHAT:
          this.toggleChat()
          break
      }
    } catch (error) {
      this.logError('Error in GreetingMessageHandler:', error)
    }
  }

  private handleGreetingReady(): void {
    try {
      if (this.state.greetingIframe) {
        this.state.greetingIframe.classList.add('ready')
      }

      this.sendMessageToGreeting('init', {
        settings: this.state.settings,
        parentColorScheme: this.getParentColorScheme()
      })
    } catch (error) {
      this.logError('Error handling greetingReady:', error)
    }
  }

  private handleResizeGreeting(payload?: Record<string, unknown>): void {
    if (!payload || !this.state.greetingIframe) return
    const { width, height } = payload
    if (typeof width === 'number') {
      this.state.greetingIframe.style.width = `${width}px`
    }
    if (typeof height === 'number') {
      this.state.greetingIframe.style.height = `${height}px`
    }
  }

  private getParentColorScheme(): 'light' | 'dark' | undefined {
    try {
      return getParentColorScheme();
    } catch (e) {
      console.error('Failed to get parent color scheme:', e)
    }
    return undefined;
  }

  private sendMessageToGreeting(type: string, payload: Record<string, unknown>): void {
    if (this.state.greetingIframe && this.state.greetingIframe.contentWindow) {
      this.state.greetingIframe.contentWindow.postMessage({ type, payload }, '*')
    }
  }
}
